export const JWT_TOKEN: string = "jwt_access_token";
export const LOGGEDIN_USER: string = "loggedIn_user";
export const LANGUAGE: string = "lang";
export const TIME_FORMAT: string = "time";
